'use client'
import { useCallback, useEffect, useState, useContext } from 'react'
import { v1 as uuidv1 } from 'uuid'
import style from './style.module.scss'
// import Button from "../ui/button";
// import PseudoLink from "../ui/pseudo-link";
// import Input from "../ui/input/input";
import FieldInput from 'components/form/field-input/input'
import { useCookie } from 'hooks/useCookie.hook'
import { useClientRequest } from 'hooks/useClientRequest.hook'
import Icon from '../ui/icon/Icon'
// import LayoutContext from "@/context/layout";

const ENDPOINT = '/cookieSettings'
const DAYMAXAGE = 365
const COOKIE_NAME = 'ufCookies'

const SETTINGS = {
    notification: {
        text: 'Наш сайт использует файлы <a class="link" href="/yuridicheskaya-informaciya/soglasie-na-obrabotku-personalnyh-dannyh">cookie</a> для улучшения пользовательского опыта, сбора статистики и представления персонализированных рекомендаций. Нажав «Принять», вы даете согласие на обработку файлов cookie в соответствии с <a href="/yuridicheskaya-informaciya/politika-v-otnoshenii-obrabotki-personalnyh-dannyh">Политикой обработки файлов cookie.</a>',
        btn_accept: 'Принять',
        btn_cancel: 'Отклонить',
        btn_tune: 'Настроить',
    },
    block: true,
    name: 'Установка счетчиков',
    text: 'Для обеспечения вашего удобства, сайт использует файлы cookie. Оставаясь на нашем сайте, Вы соглашаетесь с использованием данных технологий и <a class="link" href="https://profi.erzrf.ru/polzovatelskoe-soglashenie/">политикой конфиденциальности.</a>',
    sub_text:
        'Нажимая на кнопку «Принять», вы даёте согласие на обработку файлов cookie в соответствии с Политикой обработки файлов cookie',
    btn_accept: 'Принять',
    base_color: '#0d2dff',
    show_icon: true,
    items: [
        {
            name: 'Необходимые cookie',
            text: 'Необходимы для работы сайта и не могут быть отключены. Вы можете настроить браузер, чтобы он блокировал эти файлы cookie или уведомлял вас об их использовании, но в таком случае возможно, что некоторые разделы сайта не будут работать',
            code: 'MAIN',
            disable: true,
            scripts: {
                meta: '',
                body: '',
                footer: '',
                lazy: '',
            },
        },
        {
            name: 'Функциональные cookie',
            text: 'Являются критически важными для работы отдельных страниц сайта и обеспечивают работу полезных функций, например для онлайн-чата или формы «Забронировать товар»',
            code: 'SYSTEM',
            disable: false,
            scripts: {
                meta: '',
                body: '',
                footer: '',
                lazy: '',
            },
        },
        {
            name: 'Аналитические cookie',
            text: 'Могут использоваться для сбора данных о ваших интересах, посещаемых страницах и источниках трафика, чтобы оценивать и улучшать работу нашего сайта',
            code: 'ANALITIKA',
            disable: false,
            scripts: {
                meta: '',
                body: '',
                footer: '',
                lazy: '',
            },
        },
    ],
}

const appendScript = (html) => {
    const target = document.createElement('div')
    target.insertAdjacentHTML('beforeend', html)
    var scripts = target.getElementsByTagName('script')
    while (scripts.length) {
        var script = scripts[0]
        script.parentNode.removeChild(script)
        var newScript = document.createElement('script')
        if (script.src) {
            newScript.src = script.src
        } else if (script.textContent) {
            newScript.textContent = script.textContent
        } else if (script.innerText) {
            newScript.innerText = script.innerText
        }
        document.body.appendChild(newScript)
    }
}

function CookieModule() {
    //   const { setBodyOverflow, resetBodyOverflow, toggleInitModal } = useContext(LayoutContext);
    const [isOpen, setIsOpen] = useState(false)
    const [settings, setSettings] = useState(false)
    const [data, setData] = useState(false)
    const [state, setState] = useState(null)
    const [scripts, setScripts] = useState(false)
    const { getAjaxContent } = useClientRequest()
    const { getCookie, setCookie } = useCookie()

    const { text, items, notification: { btn_accept, btn_cancel, btn_tune } = {} } = data || {}

    const onFormChange = ({ target: { name, checked } }) => {
        setState((prev) => ({ ...prev, [name]: checked }))
    }

    const modifyAll = (flag) => {
        const updates = { ...state }
        for (const key in updates) {
            updates[key] = flag
        }
        setState(updates)
        return updates
    }

    const onAction = (state) => {
        setIsOpen(false)
        //  resetBodyOverflow();
        setCookie({
            name: COOKIE_NAME,
            value: uuidv1(),
            days: DAYMAXAGE,
        })
    }

    const onSubmit = () => {
        // toggleInitModal(true);
        const state = modifyAll(true)
        onAction(state)
        insertScript(state)
    }

    const onReject = () => {
        // toggleInitModal(true);
        const state = modifyAll(false)
        onAction(state)
    }

    const onSave = useCallback(() => {
        onAction({ ...state, MAIN: true })
        window.location.reload()
    }, [state])

    const insertScript = (state) => {
        if (!items) return
        items.forEach(({ scripts: { lazy }, code }) => {
            if (state[code]) {
                appendScript(lazy)
            }
        })
    }

    useEffect(() => {
        ;(async () => {
            const data = SETTINGS
            setData(data)
            let state = data.items.reduce((acc, curr) => {
                acc[curr.code] = false
                return acc
            }, {})
            const current = getCookie(COOKIE_NAME)
            if (!current) {
                setIsOpen(true)
            } else {
                setScripts(true)
            }
            setState(current)
        })()
    }, [])

    useEffect(() => {
        if (scripts && state) {
            insertScript(state)
        }
    }, [scripts])

    useEffect(() => {
        const callback = () => {
            setSettings(true)
            setIsOpen(true)
        }
        document.addEventListener('cookieSettings', callback)
        return () => {
            return document.removeEventListener('cookieSettings', callback)
        }
    }, [])

    if (!data) return null

    return (
        <slam-cookie>
            <div
                onClick={(ev) => ev.stopPropagation()}
                className={`${style['fixed']} ${style['blocked']} ${isOpen ? style['visible'] : ''}`}
            >
                <div className={style['wrapper']}>
                    <div className={style['inner']}>
                        <div className={style['header']} dangerouslySetInnerHTML={{ __html: text }}></div>
                        {/* {settings && (
              <form className={style["form"]} onChange={onFormChange}>
                {items.map(({ text, name, code, disable }) => {
                  return (
                    <div key={code} className={style["form-item"]}>
                      <FieldInput
                        type="checkbox"
                        label={name}
                        name={code}
                        id={code}
                        checked={disable || state[code]}
                        disabled={disable}
                      ></FieldInput>
                      <div>{text}</div>
                    </div>
                  );
                })}
              </form>
            )} */}

                        <div className={style['footer']}>
                            {!settings ? (
                                <>
                                    <div onClick={onSubmit} className="btn btn--primary">
                                        Принять
                                    </div>
                                    {/* <Button
                    name={btn_cancel}
                    mod={["light"]}
                    onClick={onReject}
                    className={style["btn"]}
                  ></Button>
                  <Button
                    name={btn_accept}
                    mod={["primary"]}
             
                    className={style["btn"]}
                  ></Button> */}
                                </>
                            ) : (
                                <></>
                                //  <Button
                                //    mod={["primary"]}
                                //    name={"Сохранить"}
                                //    onClick={onSave}
                                //  ></Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </slam-cookie>
    )
}

export default CookieModule
